/**
 * Created by sange on 27/07/2017.
 */

import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { CustomMaterialModule } from '../material/custom-material.module'
import { ButtonComponent } from './button.component'
import { ReactiveFormsModule } from '@angular/forms'

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CustomMaterialModule,
  ],
  declarations: [
    ButtonComponent,
  ],
  exports: [
    ButtonComponent,
  ]
})
export class ButtonModule {
}



// WEBPACK FOOTER //
// ./src/app/shared/button/button.module.ts